// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Frnisi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/frnisi/1.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>项目背景</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>研学规划</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>行程参考</div>
                                {/* <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>报名须知</div> */}
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/2.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/3.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/4.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/5.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/6.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/7.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/8.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/9.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/10.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/11.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/12.jpg")} /></div>

                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/13.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/14.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/15.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/16.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/frnisi/17.jpg")} /></div>

                            </div>}

                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Frnisi);